export default function TallxHeroSection() {
  return (
    <div className="tallx-hero">

      {/* TOP CONTENT */}
      <div className="tallx-hero-top">
        <img
          src="https://mgmotor.scene7.com/is/image/mgmotor/tallx-logo-012?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080"
          alt="Tallx Logo"
          className="tallx-hero-logo"
        />

        

        <p className="tallx-hero-subtext">
          The tallest, widest and longest D+ SUV.
        </p>
      </div>

      {/* BOTTOM STATS */}
     <div className="tallx-hero-stats">

  <div className="tallx-stat-box">
    <div className="tallx-stat-top">
      <span className="tallx-red-line"></span>
      <h2>1870mm</h2>
    </div>
    <p>Tall</p>
  </div>

  <div className="tallx-stat-box">
    <div className="tallx-stat-top">
      <span className="tallx-red-line"></span>
      <h2>2016mm</h2>
    </div>
    <p>Wide</p>
  </div>

  <div className="tallx-stat-box">
    <div className="tallx-stat-top">
      <span className="tallx-red-line"></span>
      <h2>5046mm</h2>
    </div>
    <p>Long</p>
  </div>

</div>

      <style>{`
        .tallx-hero {
          height: 100vh;
          width: 100%;
          background-image: url("https://mgmotor.scene7.com/is/image/mgmotor/tallx-img-002?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080");
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 60px;
          color: #fff;
        }

        .tallx-hero::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.85), rgba(0,0,0,0.2));
          z-index: 1;
        }

        .tallx-hero-top,
        .tallx-hero-stats {
          position: relative;
          z-index: 2;
        }

        .tallx-hero-logo {
          width: 390px;
          margin-bottom: 20px;
        }

        .tallx-hero-heading {
          font-size: 48px;
          font-weight: 700;
          letter-spacing: 2px;
          margin-bottom: 10px;
        }

        .tallx-hero-subtext {
          font-size: 20px;
          opacity: 0.9;
        }

        .tallx-hero-stats {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 60px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .tallx-stat-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 20%;
  }

  .tallx-stat-top {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .tallx-red-line {
    width: 30px;
    height: 4px;
    background: #e10600;
  }

  .tallx-stat-box h2 {
    font-size: 36px;
    font-weight: 700;
    margin: 0;
    letter-spacing: 1px;
  }

  .tallx-stat-box p {
    font-size: 16px;
    opacity: 0.8;
    margin-top: 8px;
  }

        /* Tablet */
        @media (max-width: 1024px) {
           .tallx-hero-stats {
      flex-direction: column;
      align-items: center;
      gap: 30px;
    }

    .tallx-stat-box {
      width: auto;
    }
        }

        /* Mobile */
        @media (max-width: 768px) {
          .tallx-hero {
            padding: 30px;
          }

          .tallx-hero-heading {
            font-size: 28px;
          }

          .tallx-hero-subtext {
            font-size: 16px;
          }

          .tallx-hero-stats {
          display:flex;
            // flex-direction: column;
            gap: 15px;
          }
            .tallx-stat-box h2 {
      font-size: 28px;
    }

    .tallx-stat-box p {
      font-size: 14px;
    }
        }
      `}</style>
    </div>
  );
}
